/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, plan: NonNullable<unknown> }} Partner_Manage_Plan_Downgrade_DescInputs */



/**
* | output |
* | --- |
* | "The customer stays on the current plan until {date}, then moves to {plan}." |
*
* @param {Partner_Manage_Plan_Downgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_downgrade_desc = /** @type {((inputs: Partner_Manage_Plan_Downgrade_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_Downgrade_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Kunde bleibt bis zum ${i?.date} auf dem aktuellen Tarif und wechselt dann zu ${i?.plan}.`)
	return /** @type {LocalizedString} */ (`The customer stays on the current plan until ${i?.date}, then moves to ${i?.plan}.`)
});